<div class="acting-profile-card-container">

    <div *ngIf="!isLargeCardDisplay">
        <div *ngFor="let product of products" class="product-badge">
            <mat-form-field appearance="outline" style="width: 100%;">
                <input matInput value="xxx" style="display: none;" />
                <mat-label>{{ product.Name }}</mat-label>

                <div style="display: flex; flex-direction: column;">
                    <div style="display: flex; flex-direction: row;">
                        <div style="padding: 8px; margin-right: 8px;">
                            <app-image srcPath="{{ product.AvatarBlobPath }}" isApiImage="false" className="app-image-small"></app-image>
                        </div>
                        <div style="display: flex; flex-direction: column; padding: 8px; margin-top: 8px;">
                            <mat-card-title style="display: inline-flex;">{{ product.Name }}</mat-card-title>
                            <div class="text-flash-medium-wrapped" style="color: grey;">
                                {{ product.Description }}
                            </div>
                        </div>
                    </div>

                    <div class="text-flash-medium-wrapped">
                        {{ product.Pitch }}
                    </div>

                    <div style="display: flex; flex-direction: row; margin-top: 24px; justify-content: right;">
                        <button mat-button (click)="appService.composeEmail('mendl@lutzangeles.com','Order request: ' + product.Name,'Dear Mendl, \r\n\r\nI would like to order\r\n\r\n    Product: ' + product.Name + '\r\n    For Date: {__/__/____}\r\n    Quantity: {__}.\r\n\r\n Please respond / confirm my order. \r\n\r\nThanks,\r\n\r\n{your_name_here}')">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            ORDER / INQUIRE
                        </button>
                    </div>
                </div>
            </mat-form-field>
        </div>
        <br *ngIf="appService.screenSize == 1" />
        <br *ngIf="appService.screenSize == 1" />
        <br *ngIf="appService.screenSize == 1" />
    </div>

    <div *ngIf="isLargeCardDisplay">
        <div *ngFor="let product of products" class="product-badge">
            <mat-form-field appearance="outline" style="width: 100%;">
                <input matInput value="xxx" style="display: none;" />
                <mat-label>{{ product.Name }}</mat-label>

                <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
                    <mat-card-title>{{ product.Name }}</mat-card-title>
                    <div class="text-flash-medium-wrapped" style="color: grey;">
                        {{ product.Description }}
                    </div>

                    <div style="margin-top: 12px;">
                        <app-image srcPath="{{ product.AvatarBlobPath }}" isApiImage="false" className="app-image-large"></app-image>
                    </div>

                    <div class="text-flash-medium-wrapped" style="margin-top: 12px;">
                        {{ product.Pitch }}
                    </div>

                    <div style="display: flex; flex-direction: row; margin-top: 24px; justify-content: right; width: 100%;">
                        <button mat-button (click)="appService.composeEmail('mendl@lutzangeles.com','Order request: ' + product.Name,'Dear Mendl, \r\n\r\nI would like to order\r\n\r\n    Product: ' + product.Name + '\r\n    For Date: {__/__/____}\r\n    Quantity: {__}.\r\n\r\n Please respond / confirm my order. \r\n\r\nThanks,\r\n\r\n{your_name_here}')">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            ORDER / INQUIRE
                        </button>
                    </div>
                </div>
            </mat-form-field>
        </div>
        <br *ngIf="appService.screenSize == 1" />
        <br *ngIf="appService.screenSize == 1" />
        <br *ngIf="appService.screenSize == 1" />
    </div>

</div>
